import { render, staticRenderFns } from "./ConfigurationListItem.vue?vue&type=template&id=70975ad0&scoped=true"
import script from "./ConfigurationListItem.vue?vue&type=script&lang=js"
export * from "./ConfigurationListItem.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationListItem.vue?vue&type=style&index=0&id=70975ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70975ad0",
  null
  
)

export default component.exports